import { render } from "./OpenEc.vue?vue&type=template&id=dc9e397e"
import script from "./OpenEc.vue?vue&type=script&lang=ts"
export * from "./OpenEc.vue?vue&type=script&lang=ts"
script.render = render

export default script